import React, { useState, useEffect } from 'react';

// hooks
import useSampleProperties from './useSampleProperties';

// utils
import { IPropertyNFTDescriptor, getPropertyMetadataForNFT, LISTING_TYPE, RENTAL_CONTRACT_SECONDS_PER_INTERVAL, SEC_IN_A_DAY } from '../platformUtils';

function useRentedOutProperties() {
    const sampleProperties = useSampleProperties(2);    //TODO: remove dummy data
    const [rentedOutProperties, setRentedOutProperties] = useState([] as IPropertyNFTDescriptor[]);

    useEffect(() => {
        //TODO: retrieve recently rented out properties from Moralis

        let fakeRentalProperties = sampleProperties.map((sampleProperty) => {
            // clone the sample property
            let property = JSON.parse(JSON.stringify(sampleProperty));

            // create a fake rental, where the tenant is 0xbbbbbbbbbbbb, the landlord is the owner, and we're halfway through a two week rental
            property.listingType = LISTING_TYPE.UNLISTED;
            property.owner = '0xbbbbbbbbbbbb';
            property.rentalInfo = {
                rentalPrice: 0.01,
                rentalCurrency: 'eth',
                rentalPeriodSec: RENTAL_CONTRACT_SECONDS_PER_INTERVAL,
                rentalStartSec: Math.floor(Date.now() / SEC_IN_A_DAY) - (7 * SEC_IN_A_DAY),
                rentalEndSec: Math.floor(Date.now() / SEC_IN_A_DAY) + (7 * SEC_IN_A_DAY),
                tenant: '0xbbbbbbbbbbbb',
                landlord: '0x1234567890abcdef', //NOTE: our fake logged in address -- remove this when we have real data
            }

            return property;
        });

        setRentedOutProperties(fakeRentalProperties);
    }, [sampleProperties]);

    return rentedOutProperties;
}
export default useRentedOutProperties;